module.exports = __webpack_public_path__ + "static/media/lolo.78f98d76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/testimonials/lolo.png
// module id = 1419
// module chunks = 0